/// <reference path="../typings/index.d.ts" />
/// <reference path="Video.d.ts" />

namespace App {
    export class Video implements IVideo {

        public inicializar(elemento: JQuery) {
            elemento.on("click", (e) => {
                e.preventDefault();
                var id = $(e.currentTarget).data('youtubeId');
                var src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1';
                $("#youtube").attr({
                    src: src,
                    referrerpolicy: 'strict-origin-when-cross-origin',
                    allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                });
                $("body").addClass("show-video-modal noscroll");
            });

            $('body').on('click', '.close-video-modal, .video-modal .overlay', (e: JQueryEventObject) => {
                this.fecharVideoModal(e);
            });

            $('body').keyup((e: JQueryEventObject) => {
                if (e.keyCode == 27) {
                    this.fecharVideoModal(e);
                }
            });
        }

        public fecharVideoModal(e: JQueryEventObject) {
            e.preventDefault();
            $("body").removeClass("show-video-modal noscroll");
            $("#youtube").attr('src', '');
        }
    }
}

